/* eslint-disable prefer-destructuring */
import ApplicationController from './application_controller';
import initializeDataTable from '../lib/datatables/initialize';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = [
    // Billing
    'agingReportDataTable',
    'authorizationsDataTable',
    'insuranceCptDataTable',
    'insuranceSummaryDataTable',
    'patientBalanceDataTable',
    'cptCodeSummaryDataTable',
    'locationSummaryDataTable',
    'billingTriageRadarChart',
    'cptRevenueDataTable',
    'therapistRevenueDataTable',
    'locationRevenueDataTable',
    // Clinical documentation
    'visitNoteBreakdownDataTable',
    'evaluationBreakdownDataTable',
    'dischargesDataTable',
    'eventsMissingDocumentationDataTable',
    'eventsMissingAttendanceDataTable',
    'unsignedClinicalDocumentationDataTable',
    // Attendance
    'clinicCanceledDataTable',
    'clientCanceledDataTable',
    'noShowDataTable',
    'missedSessionLogsDataTable',
    'presentDataTable',
    // Key metrics
    'monthlyStatsDataTable',
    'therapistStatsDataTable'
  ];

  static values = { dataTablesLoaded: Boolean };

  initialize() {
    this.dataTablesLoaded = false;
  }

  initDataTables() {
    if (!this.dataTablesLoaded) {
      this.setDataTables();
      this.dataTablesLoaded = true;
    }
  }

  authorizationsDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#authorizations-table')) {
      window.$('#authorizations-table').DataTable().destroy();
    }
    window.$('#authorizations-table').DataTable({
      order: [[7, 'asc']],
    });
  }

  billingTriageRadarChartTargetConnected() {
    this.initBillingRadarChart();
  }

  initBillingRadarChart() {
    window.pageJSLoading = true;
    import('../pages/billing_health')
      .then((module) => {
        const billingHealth = module.default;
        if (billingHealth !== undefined) {
          billingHealth();
        }
        window.pageJSLoading = false;
      })
      .catch((error) => {
        log.error('Error loading billing health module:', error);
        window.pageJSLoading = false;
      });
  }

  agingReportDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#aging-table')) {
      window.$('#aging-table').DataTable().destroy();
    }
    window.$('#aging-table').DataTable({
      order: [[1, 'desc']],
    });
  }

  visitNoteBreakdownDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#visit-note-table')) {
      window.$('#visit-note-table').DataTable().destroy();
    }
    window.$('#visit-note-table').DataTable({
      order: [[0, 'asc']],
    });
  }

  evaluationBreakdownDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#evaluation-table')) {
      window.$('#evaluation-table').DataTable().destroy();
    }
    window.$('#evaluation-table').DataTable({
      order: [[0, 'asc']],
    });
  }

  dischargesDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#discharge-table')) {
      window.$('#discharge-table').DataTable().destroy();
    }
    window.$('#discharge-table').DataTable({
      order: [[0, 'asc']],
    });
  }

  eventsMissingDocumentationDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#events-missing-documentation-table')) {
      window.$('#events-missing-documentation-table').DataTable().destroy();
    }
    window.$('#events-missing-documentation-table').DataTable({
      order: [[0, 'asc']],
    });
  }

  patientBalanceDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#patient-balances-table')) {
      window.$('#patient-balances-table').DataTable().destroy();
    }
    window.$('#patient-balances-table').DataTable({
      order: [[1, 'desc']],
    });
  }

  insuranceCptDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#insurance-cpt-payments-table')) {
      window.$('#insurance-cpt-payments-table').DataTable().destroy();
    }
    window.$('#insurance-cpt-payments-table').DataTable({
      order: [[4, 'desc']],
    });
  }

  insuranceSummaryDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#insurance-summary-table')) {
      window.$('#insurance-summary-table').DataTable().destroy();
    }
    window.$('#insurance-summary-table').DataTable({
      order: [[2, 'desc']],
    });
  }

  cptCodeSummaryDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#cpt-summary-table')) {
      window.$('#cpt-summary-table').DataTable().destroy();
    }
    window.$('#cpt-summary-table').DataTable({
      order: [[3, 'desc']],
    });
  }

  locationSummaryDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#location-summary-table')) {
      window.$('#location-summary-table').DataTable().destroy();
    }
    window.$('#location-summary-table').DataTable({
      order: [[2, 'desc']],
    });
  }

  therapistRevenueDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#therapist-revenue-table')) {
      window.$('#therapist-revenue-table').DataTable().destroy();
    }
    window.$('#therapist-revenue-table').DataTable({
      order: [[5, 'desc']],
    });
  }

  locationRevenueDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#location-revenue-table')) {
      window.$('#location-revenue-table').DataTable().destroy();
    }
    window.$('#location-revenue-table').DataTable({
      order: [[5, 'desc']],
    });
  }

  cptRevenueDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#cpt-revenue-table')) {
      window.$('#cpt-revenue-table').DataTable().destroy();
    }
    window.$('#cpt-revenue-table').DataTable({
      order: [[6, 'desc']],
    });
  }

  eventsMissingAttendanceDataTableTargetConnected() {
    this.initDataTables();
    if (window.$.fn.DataTable.isDataTable('#events-missing-attendance-table')) {
      window.$('#events-missing-attendance-table').DataTable().destroy();
    }
    window.$('#events-missing-attendance-table').DataTable({
      order: [[0, 'asc']],
    });
  }

  unsignedClinicalDocumentationDataTableTargetConnected() {
    initializeDataTable();
  }

  clinicCanceledDataTableTargetConnected(element) {
    this.initDataTables();
    this.attendancePageDataTableInit(element);
  }

  clientCanceledDataTableTargetConnected(element) {
    this.initDataTables();
    this.attendancePageDataTableInit(element);
  }

  noShowDataTableTargetConnected(element) {
    this.initDataTables();
    this.attendancePageDataTableInit(element);
  }

  missedSessionLogsDataTableTargetConnected(element) {
    this.initDataTables();
    const sessionLogs = window.$('.missed-session-logs-table', element)[0];
    if (sessionLogs && window.$.fn.DataTable.isDataTable(sessionLogs)) {
      window.$(sessionLogs).DataTable().destroy();
    }
    window.$(sessionLogs).DataTable({
      order: [[4, 'desc']],
    });
  }

  monthlyStatsDataTableTargetConnected(element) {
    this.initDataTables();
    const keyMetricsMonthly = window.$('#key-metrics-monthly', element)[0];
    if (keyMetricsMonthly && window.$.fn.DataTable.isDataTable(keyMetricsMonthly)) {
      window.$(keyMetricsMonthly).DataTable().destroy();
    }
    window.$(keyMetricsMonthly).DataTable({
      order: [[0, 'desc']],
    });
  }

  therapistStatsDataTableTargetConnected(element) {
    this.initDataTables();
    const keyMetricsMonthly = window.$('#key-metrics-therapist', element)[0];
    if (keyMetricsMonthly && window.$.fn.DataTable.isDataTable(keyMetricsMonthly)) {
      window.$(keyMetricsMonthly).DataTable().destroy();
    }
    window.$(keyMetricsMonthly).DataTable({
      order: [[8, 'desc']],
    });

    $('#dateDropdown').selectize();
    // eslint-disable-next-line prettier/prettier
    if ($("#dateDropdown").length && $("#dateDropdown")[0].selectize) {
      const selectize = $('#dateDropdown')[0].selectize;

      selectize.on('change', function(value) {
        if (value) {
          Turbolinks.visit(value);
        }
      });
    } else {
      log.error('Selectize has not been initialized on #dateDropdown');
    }
  }

  presentDataTableTargetConnected(element) {
    this.initDataTables();
    const patientsAttendanceRates = window.$('#patients-attendance-rates', element)[0];
    if (patientsAttendanceRates && window.$.fn.DataTable.isDataTable(patientsAttendanceRates)) {
      window.$(patientsAttendanceRates).DataTable().destroy();
    }
    window.$(patientsAttendanceRates).DataTable({
      order: [[5, 'desc']],
    });
    const therapistAttendanceRates = window.$('#therapists-attendance-rates', element)[0];
    if (therapistAttendanceRates && window.$.fn.DataTable.isDataTable(therapistAttendanceRates)) {
      window.$(therapistAttendanceRates).DataTable().destroy();
    }
    window.$(therapistAttendanceRates).DataTable({
      order: [[5, 'desc']],
    });
  }

  attendancePageDataTableInit(element) {
    const patients = window.$('.patients-data-table', element)[0];
    if (patients && window.$.fn.DataTable.isDataTable(patients)) {
      window.$(patients).DataTable().destroy();
    }
    window.$(patients).DataTable({
      order: [[2, 'desc']],
    });

    const therapists = window.$('.therapists-data-table', element)[0];
    if (therapists && window.$.fn.DataTable.isDataTable(therapists)) {
      window.$(therapists).DataTable().destroy();
    }
    window.$(therapists).DataTable({
      order: [[2, 'desc']],
    });

    const hours = window.$('.hours-data-table', element)[0];
    if (hours && window.$.fn.DataTable.isDataTable(hours)) {
      window.$(hours).DataTable().destroy();
    }
    window.$(hours).DataTable({
      order: [[1, 'desc']],
    });

    const days = window.$('.days-data-table', element)[0];
    if (days && window.$.fn.DataTable.isDataTable(days)) {
      window.$(days).DataTable().destroy();
    }
    window.$(days).DataTable({
      order: [[1, 'desc']],
    });
  }

  setDataTables() {
    // Method relies on $ and moment defined on window which comes from the caseloads pack
    function strip(d) {
      if (typeof d === 'string') {
        // Strip HTML tags and newline characters if possible
        d = d.replace(/(<.*?>)|(\r?\n|\r)/g, ''); // Strip out surrounding white space

        d = d.trim();
      }

      return d;
    }

    window.$.fn.dataTable.moment = function (format, locale, reverseEmpties) {
      const types = window.$.fn.dataTable.ext.type; // Add type detection

      types.detect.unshift((d) => {
        d = strip(d); // Null and empty values are acceptable

        if (d === '' || d === null) {
          return 'moment-' + format;
        }

        return moment(d, format, locale, true).isValid() ? 'moment-' + format : null;
      }); // Add sorting method - use an integer for the sorting

      types.order['moment-' + format + '-pre'] = function (d) {
        d = strip(d);
        return !moment(d, format, locale, true).isValid() ? reverseEmpties ? -Infinity : Infinity : parseInt(moment(d, format, locale, true).format('x'), 10);
      };
    };
  }
}
